/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { vappContainer } from '@/application';
import { BreadcrumbService } from '@/services/breadcrumbService';
import { headerConfig } from '../../config/header.config';
import { loadingConfig } from '../../config/loading.config';
import { settingsConfig } from '../../config/settings.config';
import { notificationConfig } from '../../config/notifications.config';
import { errorConfig } from '../../config/error.config';
import { newUserConfig } from '../../config/newUser.config';

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig },
      loading: loadingConfig,
      settings: settingsConfig,
      notifications: notificationConfig,
      error: errorConfig,
      newUser: newUserConfig,
    };
  }
}
